import {
  REPORT_BAR_REPORT_SEARCH_REQUEST,
  BAR_REPORT_DATE_SEARCH_REQUEST,
  BAR_REPORT_DATE_SEARCH_SUCCESS,
  BAR_REPORT_DATE_SEARCH_FAILURE,
  BAR_REPORT_DATE_MONTH_SEARCH_REQUEST,
  BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS,
  BAR_REPORT_DATE_MONTH_SEARCH_FAILURE,
  BAR_REPORT_DATE_WEEK_SEARCH_REQUEST,
  BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS,
  BAR_REPORT_DATE_WEEK_SEARCH_FAILURE,
  REPORT_BAR_REPORT_REQUEST,
  REPORT_BAR_REPORT_SUCCESS,
  REPORT_BAR_REPORT_FAILURE,
  REPORT_BAR_MONTH_REPORT_REQUEST,
  REPORT_BAR_MONTH_REPORT_SUCCESS,
  REPORT_BAR_MONTH_REPORT_FAILURE,
  REPORT_BAR_WEEK_SEARCH_REQUEST,
  REPORT_BAR_WEEK_SEARCH_SUCCESS,
  REPORT_BAR_WEEK_SEARCH_FAILURE,
  REPORT_BAR_REPORT_SEARCH_SUCCESS,
  REPORT_BAR_REPORT_SEARCH_FAILURE,
} from "./BarReportTypes";

//Bar Month Search
export const barMonthReportRequest = (pageNo) => ({
  type: REPORT_BAR_MONTH_REPORT_REQUEST,
  payload: pageNo,
});

export const barMonthReportSuccess = (report) => ({
  type: REPORT_BAR_MONTH_REPORT_SUCCESS,
  payload: report,
});

export const barMonthReportFailure = (error) => ({
  type: REPORT_BAR_MONTH_REPORT_FAILURE,
  payload: error,
});

//Bar Week Search
export const barWeekReportRequest = (pageNo) => ({
  type: REPORT_BAR_WEEK_SEARCH_REQUEST,
  payload: pageNo,
});

export const barWeekReportSuccess = (report) => ({
  type: REPORT_BAR_WEEK_SEARCH_SUCCESS,
  payload: report,
});

export const barWeekReportFailure = (error) => ({
  type: REPORT_BAR_WEEK_SEARCH_FAILURE,
  payload: error,
});

// Bar Day Report Actions
export const barReportRequest = (pageNo) => ({
  type: REPORT_BAR_REPORT_REQUEST,
  payload: pageNo,
});

export const barReportSuccess = (report) => ({
  type: REPORT_BAR_REPORT_SUCCESS,
  payload: report,
});

export const barReportFailure = (error) => ({
  type: REPORT_BAR_REPORT_FAILURE,
  payload: error,
});

//Bar Month Date Search
export const barMonthReportDateSearchRequest = (queryObj) => ({
  type: BAR_REPORT_DATE_MONTH_SEARCH_REQUEST,
  payload: queryObj,
});

export const barMonthReportDateSearchSuccess = (results) => ({
  type: BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS,
  payload: results,
});

export const barMonthReportDateSearchFailure = (error) => ({
  type: BAR_REPORT_DATE_MONTH_SEARCH_FAILURE,
  payload: error,
});

//Bar Week Date Search
export const barWeekReportDateSearchRequest = (queryObj) => ({
  type: BAR_REPORT_DATE_WEEK_SEARCH_REQUEST,
  payload: queryObj,
});

export const barWeekReportDateSearchSuccess = (results) => ({
  type: BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS,
  payload: results,
});

export const barWeekReportDateSearchFailure = (error) => ({
  type: BAR_REPORT_DATE_WEEK_SEARCH_FAILURE,
  payload: error,
});

//Bar Day Date Search
export const barReportDateSearchRequest = (queryObj) => ({
  type: BAR_REPORT_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const barReportDateSearchSuccess = (results) => ({
  type: BAR_REPORT_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const barReportDateSearchFailure = (error) => ({
  type: BAR_REPORT_DATE_SEARCH_FAILURE,
  payload: error,
});


//Bar Search
export const barReportSearchRequest = (query) => ({
  type: REPORT_BAR_REPORT_SEARCH_REQUEST,
  payload: query,
});

export const barReportSearchSuccess = (results) => ({
  type: REPORT_BAR_REPORT_SEARCH_SUCCESS,
  payload: results,
});

export const barReportSearchFailure = (error) => ({
  type: REPORT_BAR_REPORT_SEARCH_FAILURE,
  payload: error,
});
